import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';

export interface AppStoreState {
  /** 선택된(검색된) 지갑/토큰 주소 */
  selectedAddress: string;
  /** 현재 검색 결과 화면 모드 여부 */
  isSearchMode: boolean;
  setSelectedAddress: (address: string) => void;
  setSearchMode: (value: boolean) => void;
}

const AppStoreContext = createContext<AppStoreState | null>(null);

export function AppStoreProvider({ children }: { children: ReactNode }) {
  const [selectedAddress, setSelectedAddress] = useState('');
  const [isSearchMode, setSearchMode] = useState(false);

  const state: AppStoreState = {
    selectedAddress,
    isSearchMode,
    setSelectedAddress: useCallback((address: string) => setSelectedAddress(address), []),
    setSearchMode: useCallback((value: boolean) => setSearchMode(value), []),
  };

  return (
    <AppStoreContext.Provider value={state}>
      {children}
    </AppStoreContext.Provider>
  );
}

export function useAppStore(): AppStoreState {
  const ctx = useContext(AppStoreContext);
  if (ctx == null) {
    throw new Error('useAppStore must be used within AppStoreProvider');
  }
  return ctx;
}
